import { types } from 'mobx-state-tree';

/**
 * Typescript enum
 */

export enum Status {
    UNDEFINED_WITHDRAW_STATUS="UNDEFINED_WITHDRAW_STATUS",
    ACTIVE="ACTIVE",
    ACCEPTED="ACCEPTED",
    DENIED="DENIED",
    CANCELLED="CANCELLED",
    PENDING="PENDING"
}

/**
* Status
*/
export const StatusEnumType = types.enumeration("Status", [
    "UNDEFINED_WITHDRAW_STATUS",
    "ACTIVE",
    "ACCEPTED",
    "DENIED",
    "CANCELLED",
    "PENDING",
])
